import React from 'reactn'
import { Paper, Button, AppBar, Toolbar, IconButton, Typography, Dialog, Grid, Box, Tabs, Tab } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import CreateIcon from '@material-ui/icons/Create';
import RefreshIcon from '@material-ui/icons/Refresh'
import styles from './staff-profile.style';
import { withStyles } from '@material-ui/styles'
import { LearnerRelationship } from '../relationship';
import StaffDetails from '../staff-details';
import { setStaffDetails, STAFF_DETAILS, COMMUNICATION_TAB_TYPE, setUserCommunicationContactsData, USER_CONTEXT, setJanusProfileToken, ROLES } from '../../../../constants';
import RolesAssignments from '../roles-assignments'
import LearnerGroup from "../learner-group/learner-group";
import { UserCommunications as UserCommunication } from '../../../user-communication';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ResponseBox from '../../../response-box';
import { getStaffDetails, getLocationFeatureStatus, activateStaff, deactivateStaff, whiteListStaff } from '../../../../util/APIUtils';
import ManageStaffContainer from '../manage-staff-container';
import { ManagementService } from '../../management.service';
import SisenseDashboard from '../../../../components/sisense-dashboard';
import { isPermitted, PermissionControl } from '../../../permission-control/permission-control';
import { UserIcon } from '../../../UserIcon';
import { getUserIdFromURL } from '../../../../util/Helpers';
import { withUnleash } from '../../../../v2/core/unleash';
import { UnleashService } from '../../../../v2/services';
import UnleashProvider from '../../../../v2/core/unleash/unleashProvider';
import useTabDetailsHook from './useTabDetailsHook';
import { SSOEnabledChip } from './ssoEnabledChip'
class StaffProfile extends React.Component {
    _managementService = new ManagementService();
    TABS = {
        Details: 0,
        Communication: 1,
        Relationship: 2,
        Roles: 3,
        Learner_Group: 4,
        Sisense: 5,
    };

    state = {
        manageStaff: {
            isOpen: false,
            isEdit: false,
            isConfirmationOpen: false,
            data: null,
            statesCollection: [],
            description: null
        },
        isstaffDetailsLoading: false,
        data: STAFF_DETAILS,
        activeTab: this.TABS.Details,
        response: {
            isOpen: false,
            data: [],
            heading: ""
        },
        isLearnerProfile: false,
        staffProfileId: null
    };

    /**
     * @name handleTabChange
     * @param {number} tabID
     * @desc Handle tab change event.
     * @return {void}
     */
    handleTabChange = (activeTab) => {
        this.setState({ activeTab }, () => {
            const { unleashProps } = this.props;
            if (unleashProps.isFlagEnabled()) {
                this.setHiddenBreadcrumbItems();
            }
        });
    };

    componentWillUnmount() {
        setStaffDetails({});
        setJanusProfileToken("");
        this.setGlobal({ staffProfileID: null });
    };

    getRolesAtLocation = (locations) => {
        const location = locations.find(
            (role) => role.locationId === this.getSelectedLocation
        );
        if (location) {
            return location
                .roleName
                .split(",")
                .map(
                    role => ({
                        locationKey: location.locationId,
                        roleName: role.trim()
                    })
                );
        }
        return [];
    };


    /**
     * @name changeStaffStatus
     * @param {boolean} updatedStaffStatus
     * @desc Updates staff status with respect to param. passed.
     * @return {void}
     */
    changeStaffStatus = (updatedStaffStatus) => {
        let requestHandler = null;
        const { staffDetails, locations } = this.state.data;
        let whiteListLocationCollection = [];
        if (updatedStaffStatus) {
            requestHandler = activateStaff({
                "reactivateRequest": [
                    {
                        personId: staffDetails.personId,
                        rolesAtLocation: this.getRolesAtLocation(locations)
                    }
                ]
            });

            const activeLocationIndex = STAFF_DETAILS.locations
                .findIndex(
                    (role) => role.locationId === this.getSelectedLocation
                );
            if (activeLocationIndex > -1) {
                STAFF_DETAILS.locations[activeLocationIndex].active = true;
            }
            whiteListLocationCollection = STAFF_DETAILS.locations;
        } else {
            requestHandler = deactivateStaff({
                "personKeys": [this.state.data.staffDetails.personId]
            });
            whiteListLocationCollection = STAFF_DETAILS.locations.map(location => {
                location["active"] = false;
                return location;
            });
        };
        this.setGlobal({
            isLoading: true
        });
        requestHandler
            .then(
                (_successLog) => {
                    const { refreshStaffList, unleashProps } = this.props;

                    this.setGlobal({
                        isLoading: false
                    });
                    this.getStaffDetails(staffDetails.personId);
                    const responseData = [];
                    _successLog.successList.forEach(
                        (_successNodes) => {
                            responseData.push({
                                statusCode: _successNodes.statusCode,
                                text: `${_successNodes.email} status updated successfully.`
                            });
                        }
                    );
                    _successLog.errorList.forEach(
                        (_errorNodes) => {
                            responseData.push({
                                statusCode: _errorNodes.statusCode,
                                text: _errorNodes.statusMessage
                            });
                        }
                    );
                    this.whiteListStaff({
                        personId: staffDetails.personId,
                        locations: whiteListLocationCollection
                    });
                    this.setState({
                        response: {
                            ...this.state.response,
                            isOpen: true,
                            data: responseData
                        },
                    });
                    setStaffDetails({});

                    if (refreshStaffList) {
                        refreshStaffList();
                    }
                },
                (_errorLog) => {

                    console.error("Soemthing went wrong while setting status.");
                    setStaffDetails({});
                    this.setGlobal({
                        isLoading: false
                    });
                    this.setState({
                        staffProfile: {
                            isOpen: false,
                            staffDetails: {}
                        },
                    });
                }
            );
    };

    /**
     * @name getRoleName
     * @desc Gets role name from props passed.
     * @return {string}
     */
    getRoleType = () => {
        if (!this.state.data.locations) {
            return null;
        }
        const role = this.state.data.locations
            .find((location) => location.locationId === this.getSelectedLocation);
        if (this.props.staffRole) {
            return this.props.staffRole;
        } else if (role) {
            return role.roleType;
        };
        return null;
    };

    /**
     * @name isProfileModificationAllowed
     * @desc GET property which returns if user can modify profile or not.
     * @return {Boolean}
     */
    get isProfileModificationAllowed() {
        const { unleashProps } = this.props;
        const staffId = unleashProps.isFlagEnabled() ? this.global.staffProfileID : this.props.staffData.personId;
        return staffId != USER_CONTEXT.personId;
    };

    /**
     * @name whiteListStaff
     * @param {object} staffData
     * @desc White list's staff data if Auto_Create_Relationships is true.
     * @return {void}
     */
    whiteListStaff = async (staffData) => {
        if (this.state.isAutoCreateAvailable) {
            try {
                const requestPayload = {
                    staffPersonId: staffData.personId,
                    locations: staffData.locations.map((location) => ({
                        locationId: location.locationId,
                        status: location.active
                    }))
                };
                const whiteListStaffResponse = await whiteListStaff(requestPayload);
            } catch (e) {
                console.error(e);
            };
        }
    };

    getIcon = (roleName) => {
        switch (roleName) {
            case "Attorney":
                return <svg xmlns="http://www.w3.org/2000/svg"
                    xlink="http://www.w3.org/1999/xlink"
                    svgjs="http://svgjs.com/svgjs" version="1.1" width="45px" height="45px" x="0" y="0" viewBox="0 0 480.004 480.004"
                    space="preserve" class=""><g>
                        <g xmlns="http://www.w3.org/2000/svg">
                            <g>
                                <path d="M479.202,292.692l0.072-0.024l-78.808-171.952l19.112-9.512l-7.152-14.32l-18.632,9.28l-2.52-5.496    c-1.842-4.016-6.59-5.779-10.606-3.938c-1.742,0.799-3.139,2.196-3.938,3.938l-2.248,4.912c-13.56-6.298-28.329-9.566-43.28-9.576    h-67.2v-16h16v-16H266.25l5.752-23.016c4.416-17.673-6.33-35.58-24.003-39.997c-17.673-4.416-35.58,6.33-39.997,24.003    c-1.312,5.25-1.312,10.743,0,15.993l5.752,23.016h-13.752v16h16v16h-67.16c-14.966,0.012-29.75,3.288-43.32,9.6l-2.248-4.912    c-1.841-4.016-6.59-5.779-10.606-3.938c-1.742,0.799-3.139,2.196-3.938,3.938l-2.52,5.496l-18.632-9.32l-7.152,14.336    l19.112,9.552L0.73,292.668c-0.486,1.045-0.734,2.184-0.728,3.336c0.035,30.913,25.087,55.965,56,56h80    c30.913-0.035,55.965-25.087,56-56c-0.02-1.149-0.293-2.28-0.8-3.312l-79.024-172.6c11.487-5.332,24-8.092,36.664-8.088h67.16    v292.688l-27.312,27.312h-28.688c-22.08,0.026-39.974,17.92-40,40c0,4.418,3.582,8,8,8h224c4.418,0,8-3.582,8-8    c-0.026-22.08-17.92-39.974-40-40h-28.688l-27.312-27.312V112.004h67.2c12.664-0.004,25.177,2.756,36.664,8.088L288.73,292.668    c-0.486,1.045-0.734,2.184-0.728,3.336c0.035,30.913,25.087,55.965,56,56h80c30.913-0.035,55.965-25.087,56-56    C479.983,294.855,479.71,293.724,479.202,292.692z M136.002,336.004h-80c-19.002-0.021-35.375-13.387-39.2-32h158.4    C171.378,322.617,155.004,335.983,136.002,336.004z M171.538,288.004H20.466l73.488-160.328c1.342,0.36,2.754,0.36,4.096,0    L171.538,288.004z M226.618,22.532c6.23-7.392,17.273-8.333,24.665-2.103c0.759,0.64,1.463,1.344,2.103,2.103    c3.236,4.116,4.379,9.5,3.096,14.576l-6.728,26.896H230.25l-6.728-26.896C222.239,32.032,223.383,26.648,226.618,22.532z     M232.002,96.004v-16h16v16H232.002z M248.002,112.004v288h-16v-288H248.002z M320.002,448.004    c10.168,0.012,19.229,6.418,22.632,16H137.37c3.403-9.582,12.464-15.988,22.632-16H320.002z M268.69,432.004h-57.376l16-16h25.376    L268.69,432.004z M381.938,127.7c1.321,0.465,2.77,0.405,4.048-0.168l73.552,160.472H308.466L381.938,127.7z M424.002,336.004h-80    c-19.002-0.021-35.375-13.387-39.2-32h158.4C459.378,322.617,443.004,335.983,424.002,336.004z" fill="white" data-original="#000000" />
                            </g>
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                    </g></svg>;

            case "Learner":
                return <UserIcon />;

            default:
                return <VerifiedUserIcon />;
        };
    };

    componentDidMount() {
        const { unleashProps } = this.props;
        let profileId = (this.props.staffData ? this.props.staffData.personId : this.global.staffProfileID) || (unleashProps.isFlagEnabled() && getUserIdFromURL("users"));
        if (unleashProps.isFlagEnabled()) {
            this.setHiddenBreadcrumbItems();
        }
        this.getStaffDetails(profileId);
    };

    componentDidUpdate(nextProps, nextState) {
        const { unleashProps, staffData } = this.props;
        const { isstaffDetailsLoading, data } = this.state;
        let personId = getUserIdFromURL('users');
        let profileId = unleashProps.isFlagEnabled() ? this.global.staffProfileID : (staffData ? staffData.personId : personId);

        if (Object.keys(data).length !== 0 && personId && parseInt(data.id) !== parseInt(personId)) {
            return this.getStaffDetails(personId);
        }
        if (!isstaffDetailsLoading && data.id !== profileId && this.props.isOpen) {
            this.getStaffDetails(profileId);
        }
    };

    /**
     * @name getGroupedData
     * @param {array} userLocations
     * @desc Group's user data by location name & status.
     * @return {array} userLocationsMutated
     */
    getGroupedData = (userLocations) => {
        const userLocationsMutated = [];
        userLocations.forEach(
            (location) => {
                const dataIndex = userLocationsMutated.findIndex(_location => location.locationName === _location.locationName && location.active === _location.active);
                if (dataIndex > -1) {
                    userLocationsMutated[dataIndex].roleName += `, ${location.roleName}`;
                } else {
                    userLocationsMutated.push(location);
                };
            }
        );
        return userLocationsMutated;
    };

    /**
     * @name getStaffDetails
     * @param {number} userId
     * @desc Fetches details by user ID.
     * @return {void}
     */

    setHiddenBreadcrumbItems = () => {
        this.setGlobal({
            hiddenBreadcrumbItems: [`Staff Profile/ ${Object.keys(this.TABS)[this.state.activeTab].split('_').join(' ')}`]
        });
    };

    getStaffDetails = (userID) => {
        this.setGlobal({
            isLoading: true
        });
        this.setState({
            isstaffDetailsLoading: true
        });
        this.setState({
            data: {}
        }, () => {
            getStaffDetails(userID)
                .then(
                    (_successLog) => {
                        this.setGlobal({
                            isLoading: false
                        });
                        this.setState({
                            data: {
                                ..._successLog,
                                locations: this.getGroupedData(_successLog.locations),
                                id: userID
                            },
                            isstaffDetailsLoading: false
                        });
                        this.getFeatures(this.getSelectedLocation);
                        setStaffDetails({
                            ..._successLog,
                            id: userID
                        });
                    },
                    (_errorLog) => {
                        this.setGlobal({
                            isLoading: false,
                            selectedUser: userID,
                        });
                    }
                );
        })

    };

    /**
     * @name getSelectedLocation
     * @desc GET property to select user's active location.
     * @return {number} activeLocationId
     */
    get getSelectedLocation() {
        if (this.props.activeLocation) {
            return this.props.activeLocation;
        } else {
            // IF activeLocation IS NOT
            // FOUND IN props
            // THEN FALL BACK TO:
            const activeLocation = (this.state.data.locations || [])
                .find((location) => location.active)
            if (activeLocation) {
                return activeLocation.locationId;
            } else if (this.state.data.location) {
                // IF THERE'S NO ACTIVE LOCATION
                // THEN RETURN 1ST IN LIST
                return this.state.data.locations[0].locationId;
            }
        }
    };

    /**
    * @name getActiveStatus
    * @desc Gets active status with respect to active location passed via props.
    * @return {string}
    */
    getActiveStatus = () => {
        if (!this.state.data.locations) {
            return false;
        }
        const role = this.state.data.locations
            .find((location) => location.locationId === this.getSelectedLocation);
        if (role) {
            return role.active;
        }
        return false;
    };

    handleResponseDialog = (isOpen) => {
        this.setState({
            response: {
                ...this.state.response,
                isOpen
            }
        });
    };

    isActionsAllowed = (isAttorneyAllowed) => {
        if (this.getRoleType() === ROLES.ATTORNEY && !isAttorneyAllowed) {
            return false;
        }
        return true;
    };

    getAttorneyData = () => {
        return STAFF_DETAILS.attorneyDetails ? {
            phoneNumber: STAFF_DETAILS.attorneyDetails ? STAFF_DETAILS.attorneyDetails.telephoneNumber : "",
            lawFirmName: STAFF_DETAILS.attorneyDetails ? STAFF_DETAILS.attorneyDetails.lawFirmName : "",
            lawFirmAddress: STAFF_DETAILS.attorneyDetails ? STAFF_DETAILS.attorneyDetails.address1 : "",
            lawFirmAddress2: STAFF_DETAILS.attorneyDetails ? STAFF_DETAILS.attorneyDetails.address2 : "",
            lawFirmCity: STAFF_DETAILS.attorneyDetails ? STAFF_DETAILS.attorneyDetails.city : "",
            lawFirmState: STAFF_DETAILS.attorneyDetails ? STAFF_DETAILS.attorneyDetails.stateName : "",
            lawFirmZip: STAFF_DETAILS.attorneyDetails ? STAFF_DETAILS.attorneyDetails.zipCode : "",
        } : null;
    };

    /**
     * @name getActiveLocation
     * @desc Gets active location based upon props.
     * @return {object}
     */
    getActiveLocation = () => {
        if (!this.state.data.locations) {
            return {};
        }
        const location = this.state.data.locations
            .find((location) => location.locationId === this.getSelectedLocation);
        if (location) {
            return location;
        }
        return {};
    };

    /**
     * @name getFeatures
     * @param {number} locationId
     * @desc Fetches feature w.r.t to location.
     * @return {void}
     */
    getFeatures = async (locationId) => {
        this.setGlobal({
            isLoading: true
        });
        try {
            const isAttorneyAllowed = await getLocationFeatureStatus(locationId, this._managementService.MessagingAttorney);
            const isAutoCreateAvailable = await getLocationFeatureStatus(locationId, this._managementService.AutoCreateRelationships);

            this.setGlobal({
                isLoading: false,
            });
            this.setState({
                isAttorneyAllowed: isAttorneyAllowed.status,
                isAutoCreateAvailable: isAutoCreateAvailable.status,
            });
        } catch (e) {
            console.error(e)
            this.setGlobal({
                isLoading: false
            });
        };
    };

    handleManageDialog = (isOpen, data = null) => {
        this.setState({
            manageStaff: {
                ...this.state.manageStaff,
                data,
                isOpen
            }
        });
    };

    handleConfirmationDialog = (isConfirmationOpen, data, description = "") => {
        const manageStaff = {
            ...this.state.manageStaff,
            description,
            isConfirmationOpen
        };
        if (isConfirmationOpen) {
            manageStaff["data"] = data;
        } else {
            manageStaff["data"] = null;
        }
        this.setState({
            manageStaff
        });
    }

    onCloseHandler = () => {
        this.setState({
            activeTab: this.TABS.Details,
            data: {}
        });
        setStaffDetails({});
        setUserCommunicationContactsData(null);
        this.setGlobal({
            staffProfileID: null,
            staffSelectedLocation: null,
            isStaffProfileOpen: false
        });
        if (this.props.onCloseHandler) {
            this.props.onCloseHandler();
        }
    };

    RenderStaffDetails = () => {
        const { classes, unleashProps } = this.props;
        const locationAssignment = (isPermitted(this.global.cbacConfigFlag, this.global.permissions, "Assign_Admin_To_Different_Location", this.global.permissionIds))
        const unassignAdminToDifferentLoc = isPermitted(this.global.cbacConfigFlag, this.global.permissions, "Unassign_Admin_From_Different_Location", this.global.permissionIds)
        const profileId = unleashProps.isFlagEnabled() ? this.global.staffProfileID : this.props.staffData.personId;
        const isDisableV1MessagingEnabled = unleashProps.getClient()?.isEnabled(UnleashService.FLAGS.DISABLE_V1_MESSAGING);
        const TABS = useTabDetailsHook({ profileId, allTabs: this.TABS, global: this.global, isDisableV1MessagingEnabled });

        return (
            <>
                {this.state.data.staffDetails && (
                    <>
                        <Box
                            width="100%"
                        >
                            <ResponseBox
                                heading={this.state.response.heading}
                                isOpen={this.state.response.isOpen}
                                onClose={() => {
                                    this.handleResponseDialog(false);
                                }}
                                data={this.state.response.data}
                                groupedView={false}
                            />
                            <ManageStaffContainer
                                {...this.state.manageStaff}
                                isEdit={true}
                                isAttorneyAllowed={this.state.isAttorneyAllowed}
                                isAutoCreateAvailable={this.state.isAutoCreateAvailable}
                                refresh={() => this.getStaffDetails(this.global.staffProfileID)}
                                activeLocation={this.getActiveLocation().locationId}
                                handleManageDialog={this.handleManageDialog}
                                formDialogData={JSON.stringify(this.state.manageStaff.data)}
                                isPermissionAllowed={locationAssignment}
                                AssignedToDiffLocation={locationAssignment}
                                UnassignedToDiffLocation={unassignAdminToDifferentLoc}
                                refreshStaffList={this.props.refreshStaffList}

                            />
                            <Paper className={[classes.userProfileWrapper, !unleashProps.isFlagEnabled() ? classes.profileMargin : ''].join(" ")}>
                                <Grid container item md={12}>

                                    <Grid container
                                        alignItems="center"
                                        item md={6} >
                                        <Box component="div">
                                            <Box
                                                className={classes.blueIconContainer}
                                                component="div">
                                                {this.getIcon(this.getRoleType())}
                                                {/* <img
                                             width="45px"
                                             src="/assets/icons/balance-scale.png" /> */}
                                            </Box>
                                        </Box>
                                        <Box
                                            className={classes.userProfileInfoWrapper}
                                            component="div" display="flex" flexDirection="column">
                                            <Typography className={classes.userProfileHeading}>
                                                {this.state.data.staffDetails.displayName ? this.state.data.staffDetails.displayName : this.state.data.staffDetails.firstName + " " + this.state.data.staffDetails.lastName}                                            </Typography>
                                            <Box component="div" display="flex" flexDirection="row" alignItems="center">
                                                <Typography className={classes.userId}>
                                                    {this.getRoleType()}
                                                </Typography>
                                                <SSOEnabledChip enabled={Boolean(this.state.data?.isSSOEnrolled)} />
                                            </Box>

                                        </Box>
                                    </Grid>


                                    <Grid container
                                        direction="column"
                                        alignItems="flex-end"
                                        justify="space-between"
                                        className={classes.actionContainer}
                                        item md={6}>
                                        {this.isProfileModificationAllowed && (
                                            <>
                                                <PermissionControl
                                                    permissionName="Edit_Admins_Information"
                                                    forceRestriction={this.props.isAttorneyAllowed}
                                                >
                                                    <IconButton
                                                        onClick={() => {
                                                            const splitDisplayName = this.state.data.staffDetails.displayName.split(" ");
                                                            this.setState({
                                                                activeTab: this.TABS.Details
                                                            });
                                                            this.handleManageDialog(true, {
                                                                personId: this.state.data.staffDetails.personId,
                                                                title: this.state.data.staffDetails.title || "",
                                                                password: this.state.data.staffDetails.password || "",
                                                                firstName: this.state.data.staffDetails.firstName,
                                                                email: this.state.data.staffDetails.email,
                                                                lastName: this.state.data.staffDetails.lastName,
                                                                rolesAtLocation: this.state.data.locations,
                                                                displayFirstName: splitDisplayName.length > 0 ? splitDisplayName[0] : "",
                                                                displayLastName: splitDisplayName.length > 1 ? splitDisplayName[1] : "",
                                                                ...this.state.data.attorneyDetails
                                                            });
                                                        }}
                                                        color="primary">
                                                        <CreateIcon />
                                                    </IconButton>
                                                </PermissionControl>

                                                <PermissionControl
                                                    permissionName="Inactivate/Reactivate_Staff"
                                                >
                                                    <Button
                                                        onClick={() => {
                                                            this.setState({
                                                                activeTab: this.TABS.Details
                                                            });
                                                            this.changeStaffStatus(!this.getActiveStatus());
                                                        }}
                                                        className={classes.blueBtn}>
                                                        {this.getActiveStatus() ? "DEACTIVATE" : "ACTIVATE"}
                                                    </Button>
                                                </PermissionControl>
                                            </>
                                        )}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Box>
                        <Box
                            margin="20px 15px"
                        >
                            <Box marginBottom="20px">
                                <Tabs
                                    classes={{
                                        indicator: classes.tabIndicator,
                                        root: classes.tabContainer
                                    }}
                                    value={this.state.activeTab} onChange={(event, newVal) => { this.handleTabChange(newVal) }}>

                                    {TABS.filter((item) => !item.permissionName || isPermitted(this.global.cbacConfigFlag, this.global.permissions, item.permissionName))
                                        .map((item) => <Tab
                                            key={item.id}
                                            classes={{
                                                root: classes.tabButton,
                                                selected: classes.selectedTabButton
                                            }}
                                            label={item.label}
                                            value={item.id}
                                        />)}


                                </Tabs>
                            </Box>
                            {this.state.activeTab === this.TABS.Relationship && (
                                <LearnerRelationship
                                    isActionAllowed={this.isProfileModificationAllowed}
                                    isStaff={true}
                                    setResponse={(response) => this.setState({
                                        response
                                    })}
                                    userDetail={{
                                        userName: this.state.data.staffDetails.email,
                                        displayName: `${this.state.data.staffDetails.firstName} ${this.state.data.staffDetails.lastName}`,
                                        role: this.getRoleType(),
                                        userId: this.state.data.staffDetails.personId
                                    }}
                                    locations={STAFF_DETAILS.locations}
                                    profileUserId={this.state.data.staffDetails.personId}
                                />
                            )}
                            {this.state.activeTab === this.TABS.Details && (
                                <StaffDetails
                                    open={this.props.isOpen}
                                    {...this.state.data}
                                    roleType={this.getRoleType()}
                                />
                            )}
                            {this.state.activeTab === this.TABS.Communication && (
                                <UserCommunication
                                    isActionAllowed={this.isProfileModificationAllowed}
                                    type={COMMUNICATION_TAB_TYPE.Staff}
                                    userLocations={STAFF_DETAILS.locations}
                                    userActiveLocation={this.getActiveLocation()}
                                    history={this.props.history}
                                    profileUser={this.state.data.staffDetails}
                                />
                            )}
                            {this.state.activeTab === this.TABS.Roles && (
                                <RolesAssignments
                                    isActionAllowed={this.isProfileModificationAllowed}
                                    userDetail={this.state.data.staffDetails}
                                    roleName={this.getRoleType()}
                                    refreshStaffList={this.props.refreshStaffList}
                                />
                            )}
                            {this.state.activeTab === this.TABS.Learner_Group && (
                                <LearnerGroup />
                            )}
                            {this.state.activeTab === this.TABS.Sisense && (
                                <SisenseDashboard />
                            )}
                        </Box>
                    </>
                )
                }
            </>
        );
    }

    render() {
        const { unleashProps, classes } = this.props;
        return (
            <>
                <UnleashProvider flagName={UnleashService.FLAGS.STAFF_PROFILE_UI_PAGE}>
                    <this.RenderStaffDetails />
                </UnleashProvider>

                {!unleashProps.isFlagEnabled() &&
                    <Dialog
                        classes={{
                            paper: [classes.paper, "scroller-view"].join(" ")
                        }}
                        fullScreen open={this.props.isOpen} onClose={() => this.onCloseHandler()}>

                        {this.state.data.staffDetails && (
                            <>
                                <AppBar>
                                    <Toolbar>
                                        <IconButton edge="start" color="inherit" onClick={() => {
                                            this.onCloseHandler()
                                        }} aria-label="Close">
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography variant="h6" style={{ flexGrow: 1, color: 'white' }}>
                                            {this.state.data.staffDetails.firstName} {this.state.data.staffDetails.lastName}
                                        </Typography>
                                    </Toolbar>
                                </AppBar>
                                <this.RenderStaffDetails />
                            </>
                        )}
                    </Dialog>
                }
            </>
        )
    }
}

export default withStyles(styles)(withUnleash(StaffProfile, UnleashService.FLAGS.STAFF_PROFILE_UI_PAGE));
